import React, { memo } from 'react';
import { Images } from '../../../../../../shared/app-constants';
import EmptyList from '../../../../../../shared/design-system/components/molecules/empty-list/empty-list';

const VoicemailTemplatesEmptyState: React.FC = () => (
  <div className="voicemail-templates-empty-state d-flex justify-content-center align-items-center">
    <EmptyList
      title="No voicemail template created."
      description="Your voicemail templates will appear here, once you create new templates."
      imgSrc={Images.DialerVoicemailTemplatesEmpty}
      isVertical
    />
  </div>
);

export default memo(VoicemailTemplatesEmptyState);
